<template>
  <div
    class="position-relative text-center txt-label-primary-2"
    style="z-index: 10001!important;"
    :style="{ width: btnWidth, padding: '0 5px 0 5px', height: '1.5rem' }"
    @mouseenter="open = true"
    @mouseleave="handleMouseLeave"
  >
    <div
      class="w-100 h-100 rounded btn-candle"
      style="cursor: pointer; display: flex;
        justify-content: center; align-items: center;"
    >
      <span v-if="selectedLabel !== '-1'">
        {{
          selectedLabel
            ? selectedLabel.charAt(0).toUpperCase() + selectedLabel.slice(1)
            : "..."
        }}
      </span>
      <span v-else>
        <i class="fa fa-mouse-pointer"></i>
      </span>
    </div>

    <transition name="fade">
      <div
        v-if="open"
        class="btn-toolbar position-absolute"
        role="toolbar"
        aria-label="Toolbar with button groups"
        :style="{
          top: '120%',
          zIndex: 10002,
          height: '1.8rem',
          left: alignLeft ? '0' : undefined
        }"
      >
        <div
          class="btn-group h-100 btn-group-toggle btn-block"
          role="group"
          @mouseenter="isHoveringOptions = true"
          @mouseleave="isHoveringOptions = false"
        >
          <button
            v-for="option in options"
            :key="option.value"
            type="button"
            :style="{
              width: btnWidth,
              padding: '0 5px 0 5px',
              height: '1.8rem'
            }"
            class="btn btn-candle"
            @click="selectOption(option)"
          >
            {{ option.label }}
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "HoverMultiSelection",
  props: {
    alignLeft: { required: false, type: Boolean, default: false },
    btnWidth: { required: true, default: "6rem" },
    options: { required: true, default: [{ label: "1M", value: "1M" }] },
    selected: { required: true, default: "1M" }
  },
  data() {
    return {
      open: false,
      isHoveringOptions: false
    };
  },
  computed: {
    selectedLabel() {
      return (
        this.options.find(o => o.value === this.selected)?.label ||
        this.selected
      );
    }
  },
  methods: {
    selectOption(option) {
      this.$emit("eventOnChangeOption", option);
    },
    handleMouseLeave() {
      setTimeout(() => {
        if (!this.isHoveringOptions) {
          this.open = false;
        }
      }, 150);
    }
  }
};
</script>

<style scoped>
.hover-effect:hover {
  background-color: #f8f9fa;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease-in-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.btn-width {
  width: var(--btn-width);
  width: 4rem !important;
}
</style>
